import { useCallback } from 'react'
import { CallEnd as CallEndIcon } from '@mui/icons-material'
import { callService, callStorage } from '$logic/call'
import { t } from '$i18n'
import { useBrowserIsOnline } from '$hooks/use-browser-connection'
import { useConnectionStatus } from '$comp/main/react-hook'
import { showErrorSnackbar } from '$comp/snackbars'
import { closePvCallManager } from '$logic/router'
import { ControlButton } from './control-button'

export function OutgoingCallControls() {
  const isBrowserOnline = useBrowserIsOnline()
  const connectionStatus = useConnectionStatus()

  const handleTimeout = useCallback(() => {
    if (!isBrowserOnline || connectionStatus !== 'connected') {
      closePvCallManager()
      callStorage.resetPvMeta()
    } else {
      showErrorSnackbar(t('snackbar.call.requestFailed'))
    }
  }, [isBrowserOnline, connectionStatus])

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <ControlButton
        color="error"
        caption={t('call.cancel')}
        icon={<CallEndIcon />}
        onClick={callService.cancelOutgoingCall}
        onActionTimeout={handleTimeout}
      />
    </div>
  )
}
